import script from "./DistributeQuestionnaire.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributeQuestionnaire.vue?vue&type=script&setup=true&lang=js"

import "./DistributeQuestionnaire.vue?vue&type=style&index=0&id=92b2a9b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92b2a9b2"]])

export default __exports__